import { useState } from "react";

const Quality = () => {
    const [formData, setFormData] = useState({
        voxFile: null,
        remarks: "",
        status: "",
    });

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        setFormData({
            ...formData,
            [name]: files ? files[0] : value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        console.log("Form Data:", formData);

        alert("Quality form submitted successfully!");
    };

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
            <div className="w-full max-w-md bg-white shadow-lg rounded-2xl p-6">

                <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                    Quality Check Form
                </h2>

                <form onSubmit={handleSubmit} className="space-y-5">

                    {/* VOX File Upload */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            VOX File <span className="text-red-500">*</span>
                        </label>

                        <input
                            type="file"
                            name="voxFile"
                            onChange={handleChange}
                            required
                            className="w-full border border-gray-300 rounded-lg p-2 
                         file:mr-4 file:py-2 file:px-4
                         file:rounded-md file:border-0
                         file:text-sm file:font-semibold
                         file:bg-blue-50 file:text-blue-700
                         hover:file:bg-blue-100"
                        />
                    </div>

                    {/* Remarks */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Remarks <span className="text-red-500">*</span>
                        </label>

                        <textarea
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleChange}
                            placeholder="Enter remarks..."
                            required
                            rows="4"
                            className="w-full border border-gray-300 rounded-lg p-3 
                         focus:outline-none focus:ring-2 
                         focus:ring-blue-500"
                        />
                    </div>

                    {/* Status Dropdown */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Status <span className="text-red-500">*</span>
                        </label>

                        <select
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                            required
                            className="w-full border border-gray-300 rounded-lg p-3
                         focus:outline-none focus:ring-2
                         focus:ring-blue-500"
                        >
                            <option value="">-- Select Status --</option>
                            <option value="approved">Approved</option>
                            <option value="reject">Reject</option>
                            <option value="hold">Hold</option>
                        </select>
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="w-full bg-blue-600 hover:bg-blue-700 
                       text-white font-semibold py-3 rounded-lg
                       transition duration-300"
                    >
                        Submit
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Quality;